import {
    ADD_PROXIES,
    REVOKE_PROXIES,
    GET_PROXY_USER_LIST,
    GET_PROXY_LIST,
    INITIATE_PROXY,
    UPDATE_PROXY,
    TERMINATE_PROXY,
} from 'src/pages/more/pages/proxies/redux/action/actionTypes.js';
import {
    addProxies,
    getProxyUserList,
    getProxyList,
    updateProxy,
} from './addProxySaga';
import { revokeProxies } from './revokeProxySaga';
import { initiateProxy, terminateProxy } from './initiateProxySaga';

import { fork, all, takeLatest } from 'redux-saga/effects';

function* watchAddProxySaga() {
    yield takeLatest(ADD_PROXIES, addProxies);
}
function* watchGetUserProxySaga() {
    yield takeLatest(GET_PROXY_USER_LIST, getProxyUserList);
}
function* watchGetProxyListSaga() {
    yield takeLatest(GET_PROXY_LIST, getProxyList);
}
function* watchRevokeProxySaga() {
    yield takeLatest(REVOKE_PROXIES, revokeProxies);
}
function* watchInitiateProxySaga() {
    yield takeLatest(INITIATE_PROXY, initiateProxy);
}

function* watchUpdateProxySaga() {
    yield takeLatest(UPDATE_PROXY, updateProxy);
}

function* watchTerminateProxySaga() {
    yield takeLatest(TERMINATE_PROXY, terminateProxy);
}
export default function* proxyRootSaga() {
    yield all([
        fork(watchAddProxySaga),
        fork(watchRevokeProxySaga),
        fork(watchGetUserProxySaga),
        fork(watchGetProxyListSaga),
        fork(watchInitiateProxySaga),
        fork(watchUpdateProxySaga),
        fork(watchTerminateProxySaga),
    ]);
}
